/* eslint-disable @typescript-eslint/no-explicit-any */

export type IQueryParameters =
  | string
  | string[][]
  | Record<string, any>
  | URLSearchParams

interface IFeachProperties {
  body?: Record<string, any>
  headers?: Record<string, any>
  params?: IQueryParameters
}

export interface IRequestProperties extends RequestInit {
  url: string
  parameters: IQueryParameters
}

export class FeachError extends Error {
  constructor(
    public request: IRequestProperties,
    public response: Response,
    public data: any
  ) {
    super('Erro Interno, tente novamente mais tarde!')
  }
}

const synthesizeParameters = (parameters: IQueryParameters) => {
  const searchParameter = new URLSearchParams()

  const subParameters = (accumulatorKeys: string[], entry: any) => {
    for (const [subKey, subEntry] of Object.entries(entry)) {
      const keys = [...accumulatorKeys, subKey]
      if (subEntry !== null && typeof subEntry === 'object') {
        subParameters(keys, subEntry)
      } else {
        const firstKey = keys.shift()
        const key = keys.reduce(
          (accumulator, key) => `${accumulator}[${key}]`,
          firstKey
        )
        searchParameter.append(key, subEntry as any)
      }
    }
  }

  for (const [key, entry] of Object.entries(parameters)) {
    if (entry !== null && typeof entry === 'object') {
      subParameters([key], entry)
    } else {
      searchParameter.append(key, entry)
    }
  }

  return searchParameter
}

export async function feachData(
  url: string,
  properties: IFeachProperties = {},
  method = 'GET'
) {
  const parameters = properties.params
  if (parameters) {
    properties.params =
      typeof parameters === 'object'
        ? synthesizeParameters(parameters)
        : new URLSearchParams(parameters)
  }

  const configs: RequestInit = {
    method,
    headers: {
      Accept: 'application/json',
    },
    next: {
      revalidate: 60,
    },
  }

  if (properties.body) {
    configs['body'] = JSON.stringify(properties.body)
    configs['headers']['Content-Type'] = 'application/json'
  }

  if (properties.headers) {
    configs['headers'] = { ...configs['headers'], ...properties.headers }
  }

  const parametersString = properties.params
    ? '?' + properties.params.toString()
    : ''

  const response = await fetch(`${url}${parametersString}`, configs)
  const data = await response.json()

  if (response.status !== 200) {
    throw new FeachError({ url, parameters, ...configs }, response, data)
  }

  return data
}
